module.exports = __webpack_public_path__ + "static/img/top.e188038.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/top.png
// module id = KYSF
// module chunks = 1